// VG 2.0 · Phase 8A — Owner Workspace client.

const API = process.env.REACT_APP_BACKEND_URL;

function _headers(anonId) {
  const h = { "Content-Type": "application/json" };
  if (anonId) h["X-Anon-Session-Id"] = anonId;
  return h;
}

export async function getOwnerSummary({ anonId }) {
  const r = await fetch(`${API}/api/v2/workspace/owner`, {
    method: "GET", headers: _headers(anonId),
  });
  if (!r.ok) throw await _err(r);
  return await r.json();
}

export async function getCaseDetail({ anonId, caseId }) {
  const r = await fetch(`${API}/api/v2/workspace/owner/cases/${caseId}`, {
    method: "GET", headers: _headers(anonId),
  });
  if (!r.ok) throw await _err(r);
  return await r.json();
}

export async function postContinue({ anonId }) {
  const r = await fetch(`${API}/api/v2/workspace/owner/continue`, {
    method: "POST", headers: _headers(anonId),
  });
  if (!r.ok) throw await _err(r);
  return await r.json();
}

export async function postRestartSameProperty({
  anonId, sourceCaseId, sourcePropertyId, objective,
  scenarioType, valuationMode, operationId,
}) {
  const r = await fetch(`${API}/api/v2/workspace/owner/restart-same-property`, {
    method: "POST", headers: _headers(anonId),
    body: JSON.stringify({
      source_case_id: sourceCaseId || null,
      source_property_id: sourcePropertyId || null,
      objective, scenario_type: scenarioType,
      valuation_mode: valuationMode,
      operation_id: operationId,
    }),
  });
  if (!r.ok) throw await _err(r);
  return await r.json();
}

export async function postFullReset({ anonId, operationId }) {
  const r = await fetch(`${API}/api/v2/workspace/owner/full-reset`, {
    method: "POST", headers: _headers(anonId),
    body: JSON.stringify({ operation_id: operationId }),
  });
  if (!r.ok) throw await _err(r);
  return await r.json();
}

async function _err(r) {
  let detail;
  try { detail = await r.json(); } catch { detail = { detail: r.statusText }; }
  const err = new Error(
    (detail && detail.detail && detail.detail.message) ||
    (typeof detail?.detail === "string" ? detail.detail : r.statusText)
  );
  err.status = r.status;
  err.code = detail?.detail?.error_code || null;
  return err;
}
